/**
 * @group Constants
 * @summary
 * <blockquote>Constants for learning quiz attempt status values</blockquote>
 * 
 * @example
 * ```typescript
 * import { LEARNING_QUIZ_ATTEMPT_STATUSES } from '@shared/constants';
 * 
 * if (attempt.status === LEARNING_QUIZ_ATTEMPT_STATUSES.IN_PROGRESS) {
 *   // Handle in progress attempt
 * }
 * ```
 */
export const LEARNING_QUIZ_ATTEMPT_STATUSES = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  ABANDONED: 'abandoned'
} as const; 